import React, { useCallback, useEffect, useRef } from "react";
import LinearProgressWithLabel from "./LinearProgressWithLabel";

const AwaitingTimeoutProgress: React.FC<{
    timeoutSeconds: number;
    progressLabel: string;
    onTimeOutReached: () => void;
}> = ({ progressLabel, onTimeOutReached, timeoutSeconds }) => {
    type Timeout = ReturnType<typeof setTimeout>;
    const timeoutRef = useRef<Timeout | null>(null);

    const timeoutReachedCallback = useCallback(() => {
        onTimeOutReached();
    }, [onTimeOutReached]);

    useEffect(() => {
        if (timeoutRef.current != null) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            timeoutReachedCallback();
        }, timeoutSeconds * 1000);

        return () => {
            if (timeoutRef.current != null) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [timeoutReachedCallback, timeoutSeconds]);

    return <LinearProgressWithLabel label={progressLabel} />;
};

export default AwaitingTimeoutProgress;
